module.exports = __webpack_public_path__ + "static/media/Project2_Fig15.ef6a65a5.png";